import { useRoute } from 'vue-router';
import { OvertaxStorage } from '@/utils/overtax'

export const setUtmForTracking = () => {
  const route = useRoute()
  const { utm_source, utm_medium, ref_code, return_url, dxd_return_url, utm_campaign } = route.query

  if  (utm_source) {
    OvertaxStorage.set('utm_source', utm_source)
  } else {
    OvertaxStorage.init('utm_source')
  }

  if (utm_medium) {
    OvertaxStorage.set('utm_medium', utm_medium)
  } else {
    OvertaxStorage.init('utm_medium')
  }

  if (ref_code) {
    OvertaxStorage.set('ref_code', ref_code)
  } else {
    OvertaxStorage.init('ref_code')
  }

  if (utm_campaign) {
    OvertaxStorage.set('utm_campaign', utm_campaign)
  } else {
    OvertaxStorage.init('utm_campaign')
  }

  if  (return_url) {
    OvertaxStorage.set('return_url', return_url)
  } else {
    OvertaxStorage.init('return_url')
  }

  if (dxd_return_url) {
    OvertaxStorage.set('dxd_return_url', dxd_return_url)
  } else {
    OvertaxStorage.init('dxd_return_url')
  }
}

export const getReturnUrl = (targetUrl: string, ouid?: string, opid?: string) => {
  let tempReturnUrl = targetUrl
  if (!/^https?:\/\//i.test(tempReturnUrl)) {
    tempReturnUrl = `https://${tempReturnUrl}`
  }
  const url = new URL(tempReturnUrl)
  if (ouid && url.searchParams.has('ouid')) {
    url.searchParams.set('ouid', ouid)
  }
  if (opid && url.searchParams.has('opid')) {
    url.searchParams.set('opid', opid)
  }

  return url.toString()
}
